import { useQuery } from '@tanstack/react-query';

import { toDownloadData } from '../lib/downloadData';
import { getReportData } from './downloadsApi';

export interface DownloadTarget {
    deviceId: string;
    index: number;
}

export const downloadKeys = {
    all: ['downloads'] as const,
    report: (deviceId: string, index: number) => [...downloadKeys.all, 'report', deviceId, index] as const,
};

/** A device's record for the download page; null when the device has none. */
export const useReportDataQuery = (target: DownloadTarget | null) =>
    useQuery({
        queryKey: downloadKeys.report(target?.deviceId ?? '', target?.index ?? -1),
        queryFn: async () => {
            if (!target) return null;
            const { body } = await getReportData(target.deviceId, target.index);
            // An unknown device answers with an empty body: an answer to show, not a failure to retry.
            return body && Object.keys(body).length ? body : null;
        },
        select: toDownloadData,
        enabled: Boolean(target?.deviceId),
    });
